import React from "react";
import * as itemStyles from "./item.module.css";
import Badge from "./Badge";

const Item = (props) => {
    const {item, isActive, onMouseEnter, itemRef} = props;
    const {badge} = item;

    return (
        <div
            key={item.id}
            ref={itemRef}
            className={`${itemStyles.switcher__element} ${isActive ? itemStyles.active : ""} ${
                item.isDisabled ? itemStyles.switcher__element_disabled : ""
            }`}
            onMouseEnter={onMouseEnter}
        >
            <div className={itemStyles.element__header}>
                {item.icon && (
                    <div className={itemStyles.element__header__icon}>
                        <img src={item.icon?.url} width="24" height="24" title="icon" alt="icon" />
                    </div>
                )}
                <p className={itemStyles.element__header__title}>
                    {item.title}
                    {badge && badge.text && <Badge text={badge.text} is_new={badge.is_new} is_soon={badge.is_soon} />}
                </p>
            </div>
            {item.description && (
                <p data-description="ui" className={itemStyles.element__description}>
                    {item.description}
                </p>
            )}
        </div>
    );
};

export default Item;
